/**
 * @Author: wuyang
 * @Date: 2024/1/12
 * @Description: ""
 */

import React, { FC, PropsWithChildren } from 'react'
import { Outlet } from 'react-router'
import { DataXHeader } from '@/business-component/data-x-header/DataXHeader'

export const DataXLayout: FC<PropsWithChildren<{}>> = (props) => {
	return (
		<div className="bg-normal h-screen flex flex-col">
			<DataXHeader />
			<div className="flex-1 overflow-hidden">
				<Outlet></Outlet>
			</div>
			{/*<DataXFooter />*/}
		</div>
	)
}
